import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

import { useAppSelector } from "../../../hooks";
import { CMSFlagshipStore } from "../CMSFlagshipStore";
import { FlagshipStore } from "../FlagshipStore";
import {
    nearestFlagshipStorePageSelector,
    nearestFlagshipStoreSelector,
} from "../selectors";

type IProps = Immutable<{
    productTitle: string | null;
}> & {
    displayEmptyState: (state: boolean) => void;
};

export const NearbyFlagshipStores = (props: IProps): React.ReactNode => {
    const { productTitle, displayEmptyState } = props;
    const store = useAppSelector(nearestFlagshipStoreSelector);
    const storePage = useAppSelector(nearestFlagshipStorePageSelector);
    const hasMountedRef = React.useRef(false);

    React.useEffect(() => {
        if (!hasMountedRef.current) {
            hasMountedRef.current = true;
            return;
        }
        // Match the previous componentDidUpdate-only lifecycle.
        displayEmptyState(!store);
    });

    if (!store) {
        return (
            <p>
                <span>
                    {richT(
                        t`Please enter a ZIP Code above to find where you can test a <producttitle />.`,
                        {
                            producttitle: () => <strong>{productTitle}</strong>,
                        },
                    )}
                </span>
            </p>
        );
    }

    if (!storePage) {
        return <FlagshipStore store={store} />;
    }

    return <CMSFlagshipStore store={store} cmsProps={storePage} />;
};
